import { NumberInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface InputPaxGroupProps {
    adults: number;
    children: number;
    seniors: number;
    infants: number;
    guests: number;
    onChange: (counts: { adults: number; children: number; seniors: number; infants: number; guests: number }) => void;
}

export default function InputPaxGroup({
    adults,
    children,
    seniors,
    infants,
    guests,
    onChange
}: InputPaxGroupProps) {
    const { t } = useTranslation();

    const handleFieldChange = (field: 'adults' | 'children' | 'seniors' | 'infants' | 'guests', val: string | number) => {
        const numVal = val === '' ? 0 : Number(val);
        onChange({
            adults: field === 'adults' ? numVal : adults,
            children: field === 'children' ? numVal : children,
            seniors: field === 'seniors' ? numVal : seniors,
            infants: field === 'infants' ? numVal : infants,
            guests: field === 'guests' ? numVal : guests,
        });
    };

    return (
        <div className="grid grid-cols-2 gap-4">
            <div>
                <NumberInput
                    label={t('adults')}
                    min={0}
                    hideControls
                    value={adults || ''}
                    onChange={(val) => handleFieldChange('adults', val)}
                />
            </div>
            <div>
                <NumberInput
                    label={t('children')}
                    min={0}
                    hideControls
                    value={children || ''}
                    onChange={(val) => handleFieldChange('children', val)}
                />
            </div>
            <div>
                <NumberInput
                    label={t('seniors')}
                    min={0}
                    hideControls
                    value={seniors || ''}
                    onChange={(val) => handleFieldChange('seniors', val)}
                />
            </div>
            <div>
                <NumberInput
                    label={t('infants')}
                    min={0}
                    hideControls
                    value={infants || ''}
                    onChange={(val) => handleFieldChange('infants', val)}
                />
            </div>
            <div className="col-span-2">
                <NumberInput
                    label={t('guests_label')}
                    description={t('guests_description')}
                    min={0}
                    hideControls
                    value={guests || ''}
                    onChange={(val) => handleFieldChange('guests', val)}
                />
            </div>
        </div>
    );
}
